const STORAGE_PREFIX = 'kea.merchandising.draft.';
export const MERCHANDISING_DRAFT_STORAGE_VERSION = 1;

const storageAvailable = () =>
  typeof window !== 'undefined' && window.sessionStorage;

export const merchandisingDraftKey = ({ routeShopId, identity, schemaVersion }) =>
  `${STORAGE_PREFIX}${encodeURIComponent(String(routeShopId))}.${encodeURIComponent(String(identity))}.v${schemaVersion}`;

export function saveMerchandisingDraft(scope, draft) {
  if (!storageAvailable()) return;
  window.sessionStorage.setItem(merchandisingDraftKey(scope), JSON.stringify({
    storageVersion: MERCHANDISING_DRAFT_STORAGE_VERSION,
    schemaVersion: scope.schemaVersion,
    routeShopId: String(scope.routeShopId),
    identity: String(scope.identity),
    draft,
  }));
}

export function loadMerchandisingDraft(scope) {
  if (!storageAvailable()) return null;
  const raw = window.sessionStorage.getItem(merchandisingDraftKey(scope));
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    if (value.storageVersion !== MERCHANDISING_DRAFT_STORAGE_VERSION
      || value.schemaVersion !== scope.schemaVersion
      || value.routeShopId !== String(scope.routeShopId)
      || value.identity !== String(scope.identity)) {
      window.sessionStorage.removeItem(merchandisingDraftKey(scope));
      return null;
    }
    return value.draft || null;
  } catch (_) {
    window.sessionStorage.removeItem(merchandisingDraftKey(scope));
    return null;
  }
}

export function clearMerchandisingDraft(scope) {
  if (!storageAvailable()) return;
  window.sessionStorage.removeItem(merchandisingDraftKey(scope));
}

export function purgeMerchandisingDrafts() {
  if (!storageAvailable()) return;
  const keys = [];
  for (let index = 0; index < window.sessionStorage.length; index += 1) {
    const key = window.sessionStorage.key(index);
    if (key && key.startsWith(STORAGE_PREFIX)) keys.push(key);
  }
  keys.forEach((key) => window.sessionStorage.removeItem(key));
}
